import Config                       from '../../../State/Stores/Config/Config';
import arrayBufferToBase64          from '../../Shared/Util/arrayBufferToBase64';
import arrayBufferToString          from '../../Shared/Util/arrayBufferToString';
import extractMpxTokenFromAuthToken from '../../Shared/Util/extractMpxTokenFromAuthToken';
import stringToUint8Array           from '../../Shared/Util/stringToUint8Array';
import LoadError from '../Constants/LoadError';

/**
 * Requests a FairPlay license from the license URL provided via the
 * configuration. Applies the neccessary MPX request/response transforms.
 */

const requestLicense = (
    message: Uint8Array,
    config: Config
): Promise<Uint8Array> => {
    const {licenseUrl, releasePid, authToken} = config.drm;

    const licenseUrlWithToken = `${licenseUrl}&token=${extractMpxTokenFromAuthToken(authToken)}`;

    const body = JSON.stringify({
        getFairplayLicense: {
            releasePid,
            spcMessage: decodeURIComponent(arrayBufferToBase64(message))
        }
    });

    return fetch(licenseUrlWithToken, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body
    })
        .then(response => {
            if (!response.ok) throw new Error(response.status.toString());

            return response.arrayBuffer();
        }, () => {
            throw new Error(LoadError.LICENSE_REQUEST_FAILED);
        })
        .then(responseData => {
            const json = arrayBufferToString(responseData);
            const data = JSON.parse(json);

            const {
                getFairplayLicenseResponse: {ckcResponse}
            } = data;

            return stringToUint8Array(atob(ckcResponse));
        });
};

export default requestLicense;